import { effect, inject, Injectable, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UserSettings } from '../../api/interfaces';
import { AuthService } from '../../auth/auth.service';
import { SettingsStore } from './settings.store';

@Injectable({ providedIn: 'root' })
export class SettingsService {

    settingsStore = inject(SettingsStore);
    authService = inject(AuthService);


    // GENERAL SETTINGS

    public localeKeyOptions = this.settingsStore.localeKeyOptions;
    public languageLocale = this.settingsStore.languageLocale;
    public themeMode = this.settingsStore.themeMode;

    // DISPLAY FORMAT SETTINGS
    public dateFormat = this.settingsStore.dateFormat;
    public timeFormat = this.settingsStore.timeFormat;
    public numberLocale = this.settingsStore.numberLocale;
    public currency = this.settingsStore.currency; //not in UI yet
    public isIsoWeek = this.settingsStore.isIsoWeek;

    // V2 ITEM FILTER

    public v2TableColumnFilter = this.settingsStore.v2TableColumnFilter;
    public v2TenantPanelFilter = this.settingsStore.v2TenantPanelFilter;
    public v2TenantPanelFilterExpanded = this.settingsStore.v2TenantPanelFilterExpanded;

    // V3 ITEM FILTER

    public v3TableColumnFilter = this.settingsStore.v3TableColumnFilter;
    public v3TenantPanelFilter = this.settingsStore.v3TenantPanelFilter;
    public v3TenantPanelFilterExpanded = this.settingsStore.v3TenantPanelFilterExpanded;

    // LOCATOR ITEM FILTER

    public locatorTableColumnFilter = this.settingsStore.locatorTableColumnFilter;
    public locatorTenantPanelFilter = this.settingsStore.locatorTenantPanelFilter;
    public locatorTenantPanelFilterExpanded = this.settingsStore.locatorTenantPanelFilterExpanded;

    // USER MANAGEMENT ITEM FILTER
    public userManagementTableColumnFilter = this.settingsStore.userManagementTableColumnFilter;

    // CONTACTS
    public contactsTableColumnFilter = this.settingsStore.contactsTableColumnFilter;
    public v2ContactsTableColumnFilter = this.settingsStore.v2ContactsTableColumnFilter;
    public v3ContactsTableColumnFilter = this.settingsStore.v3ContactsTableColumnFilter;
    public syncContactTables = this.settingsStore.syncContactTables;


    // LOADING AND ERROR STATES
    public settingsLoading = this.settingsStore.debouncedSettingsLoading;
    public error = this.settingsStore.error;

    public allowCreateProductiveSetups = signal<boolean>(false);


    private translatorMode: boolean = true;

    private pendingSettings = signal<Partial<UserSettings>[]>([]);

    constructor(
        private translateService: TranslateService
    ) {

        effect(() => {
            if (this.translatorMode) {
                this.translateService.use(this.languageLocale());
            }
        });
        effect(() => {
            const user = this.authService.currentUser();
            const settings = this.pendingSettings();

            if (user && settings) {
                settings.forEach((pendingSetting) => {
                    this.saveUserSettings(pendingSetting);
                    this.pendingSettings.update(pending => pending.filter(setting => setting !== pendingSetting));
                });
                console.warn('pending settings saved.');
                // console.clear();

            }
        });
    }


    saveUserSettings(settings: Partial<UserSettings>) {
        if (!this.authService.currentUser() || this.settingsLoading()) {
            console.warn('save settings pending.');
            this.pendingSettings.update(pending => [...pending, settings]);
            return;
        }
        this.settingsStore.saveUserSettings(settings);

    };

    deleteCurrentUserSettings() {
        this.settingsStore.deleteUserSettings();
    };

    toggleAllowCreateProductiveSetups() {
        this.allowCreateProductiveSetups.update(value => !value);
    }

}
